module.exports = __webpack_public_path__ + "img/af.c77ce277.svg";